import VueRouter from "vue-router";
import routes from "./routes";
import Axios from "axios";
import store from "../store/index";
import {
  UI_SET_HEADER_HIDDEN,
  UI_SET_FOOTER_HIDDEN
} from "../store/ui/mutation-types";

const meta_title = document.querySelector('meta[name="title"]');
const meta_description = document.querySelector('meta[name="description"]');
const meta_keywords = document.querySelector('meta[name="keywords"]');

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

router.beforeEach(async (to, from, next) => {
  const headerHidden = ["404"].includes(to.name);
  const footerHidden = [
    "gifts-form",
    "nights-wizard",
    "checkout",
    "calendar",
    "404",
    "reports",
    "admin.calendar"
  ].includes(to.name);

  if (!window.location.href.includes('/gestion/')) {
    if (to.meta.dynamic) {
      try {
        const { data } = await Axios.get(`/api/${to.params.custom_url}`);
        
        document.title = data.meta.title || "Estoy Bien Mamá";
        meta_title.setAttribute("content", data.meta.title || "Estoy Bien Mamá");
        meta_description.setAttribute("content", data.meta.description || "");
        meta_keywords.setAttribute("content", data.meta.keywords || "");
      } catch (error) {
        console.error("Error cargando los metadatos dinámicos:", error);
      }
    } else {
      meta_title.setAttribute("content", to.meta.meta_title || '');
      meta_description.setAttribute("content", to.meta.meta_description || '');
      meta_keywords.setAttribute("content", to.meta.meta_keywords || '');
    }
  }

  store.commit(UI_SET_HEADER_HIDDEN, headerHidden);
  store.commit(UI_SET_FOOTER_HIDDEN, footerHidden);

  const reloadRoutes = [
    "blog-index",
    "blog-show",
    "politica-de-cookies",
    "aviso-legal",
    "terminos-y-condiciones",
    "politica-de-privacidad",
    "contact",
    "reports"
  ];
  if (reloadRoutes.includes(from.name)) {
    window.location = to.path;
    return;
  }

  window.Events.$emit("route-will-change");

  next();
});

export default router;
